import React from 'react';
import DoserDashboard from "./DoserDashboard";
import styles from './pearlDoser.module.css'
import LoadingSpinner from '../loadingSpinner'
import {pInd} from '../../../components/utils/paramIds'
import {wsTrans,getParamId2} from '../../utils/utils'
import {dbVals} from '../../../components/utils/http';
import { getDb, readJPro,readXBoards,loadRtdVals,withTimeout,senseIds,badGSValue,
} from "../C18AiUtils";
import {cl,globs,getTime,getRandomString} from '../../../components/utils/utils';

class DoserDashParent extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.state={
      loaded:false,
      selGraph:"EC",
    }
    this.subscribe_savePageEvent=globs.events
      .subscribe("savePageEvent",this.savePage)
  }

  componentDidMount=()=>{
    this.loadInfo()
    this.updJProInt=setInterval(this.updJPro,5000)
  }

  componentWillUnmount=()=>{
    clearInterval(this.updJProInt)
  }

  genSensors=["ec","ph","temp","flow","vol"]// genSense 3,4,5,6,7


  getVolSpan=async(siteId,zInd,fromTime,toTime)=>{
    let base=getParamId2(1900,"pearl_gen_sens_stat","adjValue")
    let mult=pInd[1900].pearl_gen_sens_stat[2]
    let volPid=base+(this.genSensors.indexOf("vol")+2)*mult
//     cl(volPid)
    let body={siteId,zInd,pid:volPid,fromTime,toTime}
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/totSpan", method: "retrieve",sessionId: globs.userData.session.sessionId, body: body})
    let last=+res.data.last||0
    let first=+res.data.first||0
    return(badGSValue(last)||badGSValue(first))?0:last-first
  }

  loadGenericSensors=async(zInd,site,midNite)=>{
    let now=Math.floor(getTime())
    let weekAgo=now-7*86400
    let base=getParamId2(1900,"pearl_gen_sens_stat","adjValue")
    let mult=pInd[1900].pearl_gen_sens_stat[2]
    let genSense={}
    genSense.dayVol=await this.getVolSpan(site.siteId,zInd,midNite,now)
    genSense.weekVol=await this.getVolSpan(site.siteId,zInd,weekAgo,now)
    this.genSensors.forEach((s,i)=>{
      let pid=base+(i+2)*mult
      genSense[s]=dbVals.z[zInd][240][pid]
    })
//     cl(genSense)
    return genSense
  }

  loadSpCal=(zInd)=>{
    let tab="pearl_config"
    return {
      kFact:getDb(zInd, 240, tab, "dose_k_fact", 0),
      ecSp:getDb(zInd, 240, tab, "dose_ec_sp", 0),
      ecCal:getDb(zInd, 240, tab, "dose_ec_cal", 0),
      phSp:getDb(zInd, 240, tab, "dose_ph_sp", 0),
      phCal:getDb(zInd, 240, tab, "dose_ph_cal", 0),
    }
  }

  loadRecipes=async(zInd,stateVals)=>{
    let pr=this.props
    let body={
      zoneId:pr.zoneId,
    }
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/pearlDoser", method: "retrieve",
      sessionId: globs.userData.session.sessionId, body: body})
    for(let val of res.data){
      stateVals[val.type]=val.value
    }
    stateVals.schedule=(stateVals.schedule||[]).slice(0,6)
//     stateVals.schedule.forEach(s=>{
//       if(!s.durMins){s.durMins=0}
//     })

  }

  loadAlarmHiLo=(zInd)=>{
    let tab="pearl_gen_sens_alrm"
    let idxEc=3
    let idxPh=4
    let idxFlow=6
    return {
      ecLow:getDb(zInd, 240, tab, "alarmLow", idxEc),
      ecHi:getDb(zInd, 240, tab, "alarmHigh", idxEc),
      phLow:getDb(zInd, 240, tab, "alarmLow", idxPh),
      phHi:getDb(zInd, 240, tab, "alarmHigh", idxPh),
      flLow:getDb(zInd, 240, tab, "alarmLow", idxFlow),
      flHi:getDb(zInd, 240, tab, "alarmHigh", idxFlow),
    }
  }

  getEventVol=async(siteId,zInd,midNite,ev)=>{
    if(!ev){return 0}
//     cl(siteId,zInd,midNite,ev)
    let fromTs=midNite+60*ev.dayMins
    let toTs=Math.min(fromTs+60*ev.durMins,getTime())
    return await this.getVolSpan(siteId,zInd,fromTs,toTs)
  }

  getAdvRecipe=(dayMins,tzo,recipeSegments)=>{
    cl(recipeSegments)
    let rec=recipeSegments.find(s=>s.end>dayMins)
    cl(rec)
    rec.dayMins=rec.start
    rec.durMins=rec.end-rec.start
    return rec
  }

  getCurRecipe=async(zInd,stateVals)=>{// updates stateVals
    let nutes=[];
    let {tzo,mode,recipeSegments}=this.props;
//     cl(tzo);
    (stateVals.jPlus||[]).filter(jp=>!jp.notUsed)
      .forEach((jp,i)=>{
        jp.nutes.forEach(nu=>{nutes.push(nu)})
      })
    stateVals.nutes=nutes
//     let dayMins=Math.floor(+stateVals.contTime/60%1440)
    let dayMins=Math.round(getTime()/60-tzo)%1440
//     cl(this.props)
//     cl(dayMins)
    let sched=stateVals.schedule.slice(0)
    sched.sort((a,b)=>a.dayMins-b.dayMins)
    sched.push(Object.assign({},sched[0]))
    sched[sched.length-1].dayMins+=1440
//     cl(dayMins)
//     cl(sched)
    let cur={}
    if(["advTable","advGraph"].includes(mode)){
      cur=this.getAdvRecipe(dayMins,tzo,recipeSegments)
//       cur=recipeSegments.find(s=>s.end>dayMins)

    }else{
      for(let i=0;i<sched.length;i++){
        let s=sched[i]
        if(dayMins<s.dayMins){
          cur=sched[i-1]
          cur=(i>0)&&(cur.dayMins+cur.durMins>dayMins)?cur:s
          break
        }
      }
      cur.dayMins=cur?.dayMins%1440
    }
//     cl(cur)
    stateVals.curEvent=cur
    stateVals.evVol=await this.getEventVol(
      stateVals.site.siteId,stateVals.zInd,stateVals.midNite,cur)

    let recipe=(cur)?
      (stateVals.recipes||[]).find(r=>r.recipeId==cur.recipeId)||{}:
      new Array(64)
//     cl(recipe)
    stateVals.injectors=(nutes).map((nute,i)=>{
      let jPlus=stateVals.jPlus[Math.floor(i/16)]??{}
      let jPro=stateVals.jPro[Math.floor(i/16)]??{}
      let ind=i%16
      return {
        nute:nute,//(jPlus.nutes||[])[ind],
        cps:jPro[`cps${ind}`],
        todayInject:(recipe?.concs||[])[i],
      }
    })
    stateVals.recipeNutes=(recipe.concs||[]).map((r,i)=>{
      return {inj:i,conc:r}
    })
//     cl(stateVals)
//     cl(recipe)
    stateVals.recipe=recipe
  }

  loadGrValues=async()=>{
    let {zoneId}=this.props
    let {selGraph}=this.state
    let now=Math.floor(getTime())
    let si=senseIds[selGraph]
//     let rtdVals=await loadRtdVals(zoneId,si.gsId,now-7*86400,now)
//     cl("get")
    let rtdVals=await withTimeout(loadRtdVals(zoneId,si.gsId,now-7*86400,now),2000)
//     cl(rtdVals)
    return (rtdVals[si.id]||[]).map(r=>({ts:r.t,gr:r.v}))
  }

  loadInfo=async()=>{
    let pr=this.props
//     cl(pr)
    let zInd=pr.zInd
    let zone=globs.zonesInfo.info.find(z=>z.zoneId==pr.zoneId)
    let site=globs.sitesInfo.info.find(s=>s.siteId==zone?.siteId)
    let {tzo}=this.props
    let now=Math.floor(getTime())
    let loc=now-60*tzo
    let midNite=loc-loc%86400+60*tzo
    let stateVals={
      loaded:true,
      zone:zone,
      site:site,
      zInd:zInd,
      midNite:midNite,
      contTime:getDb(zInd, 240, "snapshots", "currentTime", 0),
      genSense:await this.loadGenericSensors(zInd,site,midNite),
      spCal:this.loadSpCal(zInd),
      alHiLow:this.loadAlarmHiLo(zInd),
      xBoards:readXBoards(zInd),
      grValues:await this.loadGrValues(),
//       tzo:getTzo(site?.timeZone||"America/Los_Angeles"),
//       jPro:readJPro(zInd,0),
    }
    await this.loadRecipes(zInd,stateVals)
    stateVals.jPro=readJPro(zInd,stateVals.xBoards,stateVals.jPlus?.length||0)
//     cl(stateVals)
    await this.getCurRecipe(zInd,stateVals)
    this.setState((stateVals))
//     cl(stateVals)
  }

  updJPro=async()=>{
    let st=this.state
    let pr=this.props
    let jPro=st.jPro?.slice(0)||[]
    jPro[0]=readJPro(pr.zInd,st.xBoards,1)[0]
//     cl("get")
    let grValues=await this.loadGrValues()
//     cl("get")
    this.setState({jPro,grValues})
  }

  dashboardChange=(v)=>{
    switch(v.type){
      case "click":
        switch(v.value){
          case "info":
            globs.events.publish("showInfoPage","/doserDash")
            break
          default:
            break
        }
        break
      case "selGraph":
        this.setState({selGraph:v.value})
        cl(v)
        break
    }
  }

  showDashboard=()=>{
    let st=this.state
    let {tzo,units}=this.props
    let {jPro,grValues,genSense,injectors,recipe,curEvent,evVol,recipeNutes,selGraph}=this.state
//     cl(st)
    let jp0=jPro[0]||{}
//     cl(jp0)
//     cl(st.injectors)
//     cl(tzo)
    return(
      <div style={{ padding: "0 20px 20px" }}>
        <DoserDashboard
          systemStatus="running"
          onChange={this.dashboardChange}
          curEc={jp0.ec}
          spEc={0}
          locLoEc={jp0.ecLoAlrm}
          locHiEc={jp0.ecHiAlrm}
          calEc={0}

          grValues={grValues}
          tzo={0-tzo}

          curPh={jp0.ph}
          spPh={0}
          locLoPh={jp0.phLoAlrm}
          locHiPh={jp0.phHiAlrm}
          calPh={0}

          curFlow={10*jp0.flow}
          minFlow={0}
          maxFlow={0}
          todayFlow={100*genSense.dayVol}
          weekFlow={100*genSense.weekVol}

          injectors={injectors}

          curRecipe={{
            name: recipe?.name,
            startTime: curEvent?.dayMins||0,
            endTime: (curEvent?.dayMins||0)+(curEvent?.durMins||0),
            totalFlow: evVol,
            nutes: recipeNutes,
          }}

          kFactor={jp0.kFactor}
          units={units}
          selGraph={selGraph}
        />
      </div>
    )
  }

  render(){
    let st=this.state
    if(st.loaded){
      return(
        <div className={styles.pearlDoser}>
          {this.showDashboard()}
        </div>
      )
    }else{
      return <LoadingSpinner message="loading accesses..." />
    }
  }
}

export default DoserDashParent;
